import React, {useState} from 'react';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {Grid} from '@material-ui/core';
import PatientDetailsCard from '../../Patients/Patientdetails/PatientDetailsCard/PatientDetailsCard';
import {useSelector} from 'react-redux';
import GuarantorDetailsCard from '../../Patients/Patientdetails/GuarantorDetailsCard/GuarantorDetailsCard';
import RecordChangesCard from '../../Patients/Patientdetails/RecordChangesCard/RecordChangesCard';
import {shouldShowPatientEmrSyncActions} from '../../EmrSync/utils/patientEmrSyncStatus';

function DetailsContainer(): JSX.Element {
  // FIXME: ADD PROPER TYPES
  const patientDetailsDrawer = useSelector(
    (state: any) => state.patientDetailsDrawer
  );
  const [emrSyncRefreshKey, setEmrSyncRefreshKey] = useState(0);
  const showGuarantorEmrSyncActions = shouldShowPatientEmrSyncActions(
    patientDetailsDrawer?.patientDetails
  );

  return (
    <Grid container spacing={3}>
      {/* Patient Details */}
      <Grid item xs={12} md={6}>
        <PatientDetailsCard
          patient={patientDetailsDrawer?.patientDetails}
          patientId={patientDetailsDrawer?.patientId}
          clinicId={patientDetailsDrawer?.clinicId}
          emrSyncRefreshKey={emrSyncRefreshKey}
        />
      </Grid>

      {/* Guarantor Details */}
      <Grid item xs={12} md={6}>
        <GuarantorDetailsCard
          guarantorId={patientDetailsDrawer?.patientDetails?.guarantor_id}
          clinicId={patientDetailsDrawer?.clinicId}
          isGuarantorDrawerLink={true}
          goToMessagesTab={true}
          showEmrSyncActions={showGuarantorEmrSyncActions}
          forceUpdate={emrSyncRefreshKey}
          onEmrStatusChange={() => setEmrSyncRefreshKey(key => key + 1)}
        />
      </Grid>
      <Grid item xs={12}>
        <RecordChangesCard patientId={patientDetailsDrawer?.patientId} />
      </Grid>
    </Grid>
  );
}

export default DetailsContainer;
